import { Box, Tag, Text } from '@wix/design-system';
import React, { useEffect, useMemo, useState } from 'react';
export const Timer = _ref => {
  let {
    initialTime,
    onTimeout
  } = _ref;
  const [remainingSeconds, setRemainingSeconds] = useState(() => Math.floor(initialTime / 1000.0));
  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingSeconds(prevSeconds => Math.max(prevSeconds - 1, 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [initialTime]);
  useEffect(() => {
    if (remainingSeconds === 0) {
      onTimeout();
    }
  }, [remainingSeconds]);
  const timerText = useMemo(() => {
    const minutes = Math.floor(remainingSeconds / 60.0);
    const seconds = remainingSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }, [remainingSeconds]);
  return /*#__PURE__*/React.createElement(Tag, {
    id: "timer",
    skin: "warning",
    size: "tiny",
    removable: false
  }, /*#__PURE__*/React.createElement(Box, {
    minWidth: "40px",
    align: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, timerText)));
};
//# sourceMappingURL=Timer.js.map